import { Chip } from "@mui/material";
import moment from "moment";
import { getCfStatusChipSx, getCfStatusLabel } from "../../utils/constants";
import { render } from "@testing-library/react";

// Terminal form statuses shown directly (not via the per-step stage).
export const TERMINAL_STATUSES = ["DROPPED", "OPENED"];
// Form statuses shown directly (not via the per-step stage) — terminal statuses plus
// EXCEPTION_PENDING, which is also a form-level status distinct from the current step's stage.
export const DIRECT_DISPLAY_STATUSES = [...TERMINAL_STATUSES, "EXCEPTION_PENDING"];
export const CF_STATUS_OPTIONS = [
  { label: "Lead", value: "LEAD" },
  { label: "Under Discussion", value: "UNDER_DISCUSSION" },
  { label: "CF Approved", value: "APPROVED" },
  { label: "Under Construction", value: "UNDER_CONSTRUCTION" },
];


export const getV2HeaderConfig = (userMap) => {
  let headerConfig = [
    {
      label: "CF ID",
      id: "id",
      render: (data, onClick) => (
        <span
          onClick={() => onClick(data, "view-details")}
          style={{
            cursor: "pointer",
            color: "#008938",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          {data?.id || data?._id}
        </span>
      ),
    },
    {
      label: "Site Name",
      id: "siteName",
    },
    {
      label: "Region",
      id: "address.region",
      render: (data) => <span>{data?.address?.region || "N/A"}</span>,
    },
    {
      label: "Circle",
      id: "address.circle",
      render: (data) => <span>{data?.address?.circle || "N/A"}</span>,
    },
    {
      label: "City",
      id: "address.city",
      render: (data) => <span>{data?.address?.city || "N/A"}</span>,
    },
    {
      label: "Relocated",
      id: "relocated",
      render: (data) => (data?.relocated ? "Yes" : "No"),
    },
    {
      label: "Part of AOP list",
      id: "partOfAOP",
      render: (data) =>
        data?.partOfAOP ? "Yes" : "No",
    },
    {
      label: "Current Step",
      id: "currentStep",
      render: (data) => {
        const currentStep = data.currentStepDetails;
        return <span className="cf-v2-table-current-step">{currentStep ? `Step ${currentStep.stepNumber} - ${currentStep.name}` : "N/A"}</span>;
      }
    },
    {
      label: "Status",
      id: "status",
      render: (data) => {
        if (DIRECT_DISPLAY_STATUSES.includes(data.status)) {
          return <Chip label={getCfStatusLabel(data.status)} size="small" variant="outlined" sx={getCfStatusChipSx(data.status)} />;
        }
        const currentStep = data.currentStepDetails;
        return <span>{currentStep ? <Chip label={getCfStatusLabel(currentStep.cfStatus)} size="small" variant="outlined" sx={getCfStatusChipSx(currentStep.cfStatus)} /> : "N/A"}</span>;
      }
    },
    {
      label: "Store Code",
      id: "storeCode",
      render: (data) => {
        if (!data.storeCode) {
          return "-"
        }
        return <span className="cf-v2-table-store-code">{`${data.storeCode}-${data.sequenceCode || 'X'}-${data.satelliteCode || 'X'}`}</span>
      }
    },
    {
      label: "Created By",
      id: "createdBy",
      render: (data) => <span>{userMap[data?.createdBy] || "N/A"}</span>,
    }
  ];


  return headerConfig;
};
